import styled from "styled-components";

const DocsIconWrapper = styled.svg`
    width: 22px;
    fill: grey;
    &:hover path {
      fill: var(--color-brand-pink-primary);;
    }
`;

const DocsIcon = () => {
    return (
        <DocsIconWrapper xmlns="http://www.w3.org/2000/svg" className="st0"  viewBox="0 0 22 22.001">
            <g>
                <path className="st0" d="M16.7,4.2v9.1c0,0.7-0.6,1.3-1.3,1.3H7.5c-0.7,0-1.3-0.6-1.3-1.3V1.9c0-0.7,0.6-1.3,1.3-1.3H13
		c0.3,0,0.7,0.1,0.9,0.4l2.3,2.3C16.5,3.5,16.7,3.8,16.7,4.2z M15.8,13.3V5h-2.8c-0.4,0-0.7-0.3-0.7-0.7V1.5H7.5
		C7.2,1.5,7,1.7,7,1.9v11.4c0,0.2,0.2,0.4,0.4,0.4h7.9C15.6,13.7,15.8,13.5,15.8,13.3z M14,7.3c0,0.2-0.1,0.3-0.3,0.3H9.1
		c-0.2,0-0.3-0.1-0.3-0.3V7c0-0.2,0.1-0.3,0.3-0.3h4.6C13.9,6.7,14,6.9,14,7V7.3z M14,9c0,0.2-0.1,0.3-0.3,0.3H9.1
		C8.9,9.3,8.8,9.2,8.8,9V8.8c0-0.2,0.1-0.3,0.3-0.3h4.6c0.2,0,0.3,0.1,0.3,0.3V9z M14,10.8c0,0.2-0.1,0.3-0.3,0.3H9.1
		c-0.2,0-0.3-0.1-0.3-0.3v-0.2c0-0.2,0.1-0.3,0.3-0.3h4.6c0.2,0,0.3,0.1,0.3,0.3V10.8z M13.4,1.6c-0.1-0.1-0.1-0.1-0.2-0.1v2.6h2.6
		c0-0.1-0.1-0.1-0.1-0.2L13.4,1.6z"/>
            </g>
        </DocsIconWrapper>
    );

}
export default DocsIcon;
